import { render, staticRenderFns } from "./BvnStatus.vue?vue&type=template&id=a8678348&scoped=true"
import script from "./BvnStatus.vue?vue&type=script&lang=js"
export * from "./BvnStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8678348",
  null
  
)

export default component.exports